<app-header></app-header>
<div class="content_wrapper">

    <!--Header summary-->
    <div class="summary-head mention-sec">
        <div class="wrapper">
            <span class="heading-period">
                <div class="summary-title">
                    <i class="fa fa-heart-o"></i><h2 class="">Project comparison</h2>
                </div>
            </span>
            <div class="datepicker-wrapper">
                <span class="heading-period"><span>Pick a date range and period :</span></span>
                <div class="periodpicker-wrapper">

                </div>
                <div class="popover-wrapper">
                    <input type="text"
                           ngxDaterangepickerMd
                           [(ngModel)]="selected"
                           [alwaysShowCalendars]="alwaysShowCalendars"
                           [ranges]="ranges"
                           [showClearButton]="true"
                           [showCancel]="true"
                           [linkedCalendars]="true"
                           [locale]="{applyLabel: 'Apply'}"
                           (datesUpdated)="datesUpdated($event)"
                           [keepCalendarOpeningWithRange]="keepCalendarOpeningWithRange"
                           [showRangeLabelOnInput]="showRangeLabelOnInput"
                           class="form-control"/>
                </div>
            </div>
        </div>
        <div class="chart-sec-mention compare-chart">
            <div class="spinner-border" [style.display]="mmapLoading ? 'block' : 'none'"></div>
            <canvas baseChart
                    [datasets]="lineChartData"
                    [options]="lineChartOptions"
                    [plugins]="lineChartPlugins"
                    [legend]="lineChartLegend"
                    [chartType]="lineChartType"
                    [plugins]="lineChartPlugins">
            </canvas>
        </div>
    </div>

    <div class="row" *ngFor="let sources of sourcesDoughnutChart">
        <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="panel-filter mt-2 compare-top">
                <div class="filter-header">
                    <div class="summary-title">
                        <h2 class="">Project: {{sources.project}}</h2> <span class="float-right" *ngIf="project_id != sources.id" (click)="remove_chart(sources.id)"><i class="fa fa-remove"></i>Remove</span>
                    </div>
                </div>
                <div class="panel_filter_options mention-fit row compare-chart-sec">
                    <div class="col-lg-3 col-md-12 col-sm-12">
                        <div class="categories_switch switch-compare">
                            <a class="">
                                <div class="results_type"><p>All</p><h5 [innerHtml]="sources.count.all"><img src="assets/images/small-loader.gif"></h5>
                                </div>
                            </a>
                            <a class="">
                                <div class="results_type"><p>Positive</p><h5 class="infograph_stat_pos" [innerHtml]="sources.count.positive"><img src="assets/images/small-loader.gif"></h5>
                                </div>
                            </a>
                            <a class="">
                                <div class="results_type"><p>Negative</p><h5 class="infograph_stat_neg" [innerHtml]="sources.count.negative"><img src="assets/images/small-loader.gif"></h5>       
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-5 col-md-12 col-sm-12">
                        <canvas baseChart 
                                [data]="sources.source_data.data"
                                [labels]="sources.source_data.labels"
                                [colors]="sources.source_data.colours"
                                [legend]="doughnutChartLegend"
                                [options]="doughnutChartOptions"
                                [chartType]="doughnutChartType">
                        </canvas>
                    </div>
                    <div class="col-lg-4 col-md-12 col-sm-12">
                        <canvas baseChart 
                                [data]="sources.sentiment_data"
                                [labels]="sentimentDoughnutChartLabels"
                                [colors]="sentimentDoughnutChartColors"
                                [legend]="doughnutChartLegend"
                                [options]="sentimentDoughnutChartOptions"
                                [chartType]="doughnutChartType">
                        </canvas>
                    </div>
                </div>
            </div>
        </div> 
    </div>
    <div *ngIf="projects.length != 0" class="show-more">
        <button type="button" class="submit-mention btn" (click)="compare_projects()">Compare Projects</button>
    </div>
</div>
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "rgb(199, 28, 109)" type = "square-loader" [fullScreen] = "true"></ngx-spinner>
<app-footer></app-footer>